import { jsx as _jsx } from "react/jsx-runtime";
import { memo } from 'react';
const SvgIconDownArrowSolid = (props) => (_jsx("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "currentColor", focusable: false, ...props, children: _jsx("path", { d: "M11.178 19.569a.998.998 0 0 0 1.644 0l9-13A.999.999 0 0 0 21 5H3a1.002 1.002 0 0 0-.822 1.569l9 13z" }) }));
const Memo = memo(SvgIconDownArrowSolid);
export default Memo;
//# sourceMappingURL=IconDownArrowSolid.js.map